import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const TermsCancellation = () => {
  return (
    <div className="terms-cancellation-page">
      <Navigation />

      <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-6">
            <h1 className="font-serif text-4xl mb-4">Cancellation Policy</h1>
            <div className="text-grayWarm max-w-3xl mx-auto text-left leading-relaxed">
              <p className="mb-4">We understand that plans can change. To provide the best experience for all our clients, please review our cancellation policy:</p>

              <ul className="list-disc list-inside mb-4">
                <li className="mb-2">Cancellations made at least 24 hours before your scheduled appointment will receive a full refund or credit towards a future session.</li>
                <li className="mb-2">Cancellations made within 24 hours of your appointment may incur a cancellation fee of 50% of the session price.</li>
                <li className="mb-2">No-shows or missed appointments will be charged the full session fee.</li>
              </ul>

              <p className="mb-2">To cancel or reschedule, please contact us via email or through our website’s booking system.</p>

              <p>Thank you for your understanding and cooperation.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsCancellation;
